// import './style.css';
import axios from 'axios';
import { Modal, Input } from 'antd';
import React, { useState, useEffect } from 'react';
import { LOGBOOK } from '../../../../commons/api';
import { UploadOutlined } from '@ant-design/icons';
import localStorage from '../../../../utils/localStorage';
import StyledTable from "../../../../commons/styles/table";

const SelectNestedComponent = (props) => {
  const [optionList, setOptionList] = useState([]);
  const [currentOption, setCurrentOption] = useState([]);
  const [selectedValue, setSelectedValue] = useState([]);
  const [current, setCurrent] = useState(1);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    getMaximoList();
  }, []);

  const getMaximoList = () => {
    let accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'GET',
      url: `${LOGBOOK.DropDown}?SiteId=1`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    };

    axios(headers)
      .then((response) => {
        if (Array.isArray(response.data)) {
          setOptionList(response.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const openModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
    setSelectedValue([]);
    setCurrentOption(optionList);
    setCurrent(1);
  };

  const columns = [
    {
      title: 'Failure Code',
      dataIndex: 'value',
      key: 'value',
    },
    {
      title: 'Type',
      dataIndex: 'Type',
      key: 'Type',
    },
    {
      title: 'Description',
      dataIndex: 'FailureDescription',
      key: 'FailureDescription',
    },
  ];

  return (
    <div>
      <span>
        <Input
          style={{ width: 120 }}
          
          value={props.text && props.text !== '' ? props.text : undefined}
        />
        <UploadOutlined
          onClick={openModal}
          style={{  cursor: 'pointer' }}
        />
      </span>
      
      <Modal
        title="Select"
        open={visible}
        onOk={undefined}
        onCancel={handleCancel}
      >
        {currentOption && Array.isArray(currentOption) && currentOption.length > 0 ? (
          <StyledTable size="small"
            dataSource={currentOption}
            columns={columns}
            onRow={(record) => ({
              onClick: () => {
                const newSelectedValue = [...selectedValue, record];
                setSelectedValue(newSelectedValue);
                setCurrentOption(record.child || []);
                setCurrent(current + 1);

                if (current === 4) {
                  handleCancel();
                  props.NestedSelectOnChange(newSelectedValue);
                }
              },
            })}
          />
        ) : (
          <div>No data</div>
        )}
      </Modal>
    </div>
  );
};

export default SelectNestedComponent;
